import React from "react";
import { Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { SETUP_STEPS, TEMPLATE_REQUIREMENTS } from "./setupConfig";
import "./RTMSetupStepper.css";

const RTMSetupStepper = ({ mappings, getStepStatus }) => {
  // Determine which steps to show
  const visibleSteps = React.useMemo(() => {
    // Default steps to show on load
    const defaultSteps = ["template", "project", "issueTypes"];
    
    if (!mappings.template) {
      return SETUP_STEPS.filter(s => defaultSteps.includes(s.key));
    }

    const required = TEMPLATE_REQUIREMENTS[mappings.template] || [];
    return SETUP_STEPS.filter(step => 
      step.key === "template" || required.includes(step.key)
    );
  }, [mappings.template]);

  const completedCount = visibleSteps.filter(step => getStepStatus(step.key) === "completed").length;
  
  const fillWidth = visibleSteps.length > 1 
    ? `${((completedCount) / (visibleSteps.length - 1)) * 100}%` 
    : "0%";

  return (
    <Box className="modern-stepper-wrapper">
      <div className="empty-badge">Setup Required</div>

      <div className="stepper-horizontal-content">
        <div className="stepper-illustration">
          <AutoFixHighIcon />
        </div>

        <div className="stepper-main-group">
          {/* Header Captions */}
          <div className="stepper-header">
            <div className="setup-title">Complete the setup to continue</div>
            <div className="setup-subtitle">Select the required fields above to continue mapping</div>
          </div>
          
          <div className="modern-stepper">
            <div 
              className="stepper-progress-fill" 
              style={{ width: completedCount === visibleSteps.length ? '100%' : fillWidth }}
            ></div>

            {visibleSteps.map((step, index) => {
              const status = getStepStatus(step.key);
              const isCompleted = status === "completed";
              const isActive = status === "active";

              return (
                <div 
                  key={step.key} 
                  className={`stepper-item ${isCompleted ? "completed" : isActive ? "active" : ""}`}
                >
                  <div className="step-circle">
                    {isCompleted ? <CheckIcon sx={{ fontSize: 18 }} /> : index + 1}
                  </div>
                  <div className="step-label">{step.label}</div>
                </div>
              );
            })}
          </div>

          {/* Footer Hint */}
          <div className="setup-footer">
            <div className="setup-hint">
              Content will load automatically once setup is complete.
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default RTMSetupStepper;
